import React from "react"
import { Link } from 'react-router-dom'
import {
  Icon,
  Dropdown,
} from 'rsuite';
import { useTranslation } from "react-i18next";

export const NewLeagues = () => {
  const { t } = useTranslation();
  return(
    <Dropdown
      className="drop_leagues"
      title={t('paid-leagues.generatePaidLeague')}
      trigger={['click']}
      icon={<Icon icon="plus-square-o" />}
      placement="bottomEnd"
      size="md"
      appearance="primary"
    >
      <Link className="rs-dropdown-item-content" to="/leagues-single">{t('paid-leagues.uniquePaidLeague')}</Link>
      <Dropdown.Item divider />
      <Link className="rs-dropdown-item-content" to="/leagues-bulk">{t('paid-leagues.bulkPaidLeagues')}</Link>
    </Dropdown>
  )
}
